/*=========================================================================================
  File Name: moduleTitleState.js
  Description: Title Module State
==========================================================================================*/

export default {
	titles: [],
	totalTitles: 0,
	showTitleCategorySidebar: false,
	roles: []
};
